import React from "react";

import { CartItemModel } from "@redux/modules/api/data/cart/@types/cart.model";

import { ShoppingCartSummaryItem } from "../shoppingCartItem/shoppingCartSummaryItem.component";
import ProductGroupTitleComponent from "./productGroupTitle.component";

type ProductGroupBlockComponentProps = {
    title: string;
    icon: string;
    cartItems: CartItemModel[];
    storeFullName?: string;
    isMiniCart: boolean;
    inAnimation: boolean;
    isClickAndCollect: boolean;
    activeId?: string;
    removeFromCart?: (id: string, quantity: number, free: boolean) => void;
    productLinkingAvailable?: boolean;
};

const ProductGroupBlockComponent = ({
    cartItems,
    icon,
    title,
    storeFullName,
    isMiniCart,
    inAnimation,
    isClickAndCollect = false,
    activeId,
    removeFromCart,
    productLinkingAvailable,
}: ProductGroupBlockComponentProps) => (
    <section>
        <ProductGroupTitleComponent
            icon={icon}
            isClickAndCollect={isClickAndCollect}
            isMiniCart={isMiniCart}
            title={title}
            storeFullName={storeFullName}
        />
        <div className="shoppingCartSummary__summary">
            {cartItems.map((productObject, index) => {
                return (
                    <ShoppingCartSummaryItem
                        inAnimation={inAnimation}
                        cartItem={productObject}
                        key={index}
                        activeId={activeId}
                        removeFromCart={removeFromCart}
                        productLinkingAvailable={!!productLinkingAvailable}
                    />
                );
            })}
        </div>
    </section>
);

export default ProductGroupBlockComponent;
